import { useState, useCallback, useEffect } from "react";

export function useOnSiteMode() {
  const [isOnSite, setIsOnSite] = useState(() => {
    if (typeof window === "undefined") return false;
    const params = new URLSearchParams(window.location.search);
    return params.get("onsite") === "true";
  });

  const setMode = useCallback((onSite: boolean) => {
    setIsOnSite(onSite);
    if (typeof window !== "undefined") {
      const url = new URL(window.location.href);
      url.searchParams.set("onsite", String(onSite));
      window.history.replaceState({}, "", url.toString());
    }
  }, []);

  return { isOnSite, setMode };
}
